import { CompanyAvatar } from '@/components/company-avatar';
import { renderRouterLink } from '@/lib/render-link';
import type { Company } from '@mss_creator/shared';
import { Card } from '@pms-digital/design-system';
import type { ReactNode } from 'react';

export interface CompanyCardProps {
  company: Company;
  /** The « ⋯ » menu, rendered top right above the card's link. */
  actions?: ReactNode;
}

/**
 * Grid card for one company. The whole card is a link to the company, through
 * the title (`titleHref`, the package's stretched link), so that the « ⋯ »
 * button (issue #20) is not nested inside an anchor and does not open the
 * company.
 */
export function CompanyCard({ company, actions }: CompanyCardProps) {
  return (
    <Card
      title={company.name}
      titleHref={`/companies/${company.id}`}
      renderLink={renderRouterLink}
      titleLevel={2}
      align="center"
      visual={<CompanyAvatar company={company} />}
      {...(actions ? { trailing: actions } : {})}
    />
  );
}
